"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShopItemSkeleton = exports.Root = exports.ProductList = exports.ProductBox = exports.Header = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _productBox = require("@ori/product-box");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'block',
  padding: theme.spacing(0, 0, 6),
  [theme.breakpoints.up('lg')]: {
    width: '100%',
    height: '100%',
    padding: theme.spacing(0, 0, 12),
    boxSizing: 'border-box',
    background: theme.palette.common.white,
    overscrollBehavior: 'contain',
    overflowY: 'auto'
  }
}));
const Header = exports.Header = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: 'block',
  paddingBottom: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    display: 'none'
  }
}));
const ProductList = exports.ProductList = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  single
}) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, 165px)',
  gap: theme.spacing(3, 2),
  justifyItems: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  alignContent: 'center',
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: '1fr 1fr',
    padding: theme.spacing(0, 2, 0, 0),
    ...(single && {
      gridTemplateColumns: '1fr'
    })
  }
}));
const ShopItemSkeleton = exports.ShopItemSkeleton = (0, _mui.styled)(_productBox.ProductBoxSkeleton)(({
  theme
}) => ({
  minWidth: 165,
  maxWidth: 282,
  [theme.breakpoints.up('lg')]: {
    width: 202
  }
}));
const ProductBox = exports.ProductBox = (0, _mui.styled)(_productBox.ProductBox)(({
  theme
}) => ({
  height: '100%',
  minWidth: 165,
  maxWidth: 282,
  [theme.breakpoints.up('lg')]: {
    width: 202
  }
}));
